/**
 * Accessibility hook for reduced motion preferences
 *
 * Respects user's prefers-reduced-motion setting.
 * When enabled, disables parallax, loops, and simplifies to basic opacity fades.
 */

import { useReducedMotion as useFramerReducedMotion } from 'framer-motion'

export function useReducedMotion(): boolean {
  const shouldReduceMotion = useFramerReducedMotion()
  return shouldReduceMotion ?? false
}

/**
 * Get motion-safe animation props
 * Returns reduced/no animation when user prefers reduced motion
 */
export function useMotionSafe<T extends Record<string, unknown>>(
  fullMotion: T,
  reducedMotion: Partial<T>
): T {
  const shouldReduce = useReducedMotion()
  return shouldReduce ? { ...fullMotion, ...reducedMotion } : fullMotion
}

